<template>
  <edit-view
    v-if="fetchedCardState === 'edit'"
    :sign-message-params="props.signMessageParams"
    :card-data-event-types="props.cardData.eventTypes"
  />
  <preview-view
    v-if="fetchedCardState === 'preview'"
    :card-data="props.cardData"
    :props="props.inputs"
  />
  <alert-history-view
    v-if="fetchedCardState === 'history'"
    @on-detail-selected="handleSelectDetail"
  />
</template>

<script lang="ts" setup>
import {
  NotifiFrontendClient,
  SupportedCardConfigType,
} from '@notifi-network/notifi-frontend-client';
import { storeToRefs } from 'pinia';
import { EditView } from '..';
import AlertHistoryView from '../alertHistory/AlertHistoryView.vue';
import { useNotifiStore } from '../../../stores';
import { PreviewView } from '../preview';
import { Types } from '@notifi-network/notifi-graphql';

const props = defineProps<{
  cardData: SupportedCardConfigType;
  signMessageParams: Parameters<NotifiFrontendClient['logIn']>[0];
  inputs?: Record<string, string | undefined>;
}>();

const emit = defineEmits(['onAlertDetailSelected']);

const handleSelectDetail = (
  sourceItem?: Types.NotificationHistoryEntryFragmentFragment,
) => {
  emit('onAlertDetailSelected', sourceItem);
};

const notifiStore = useNotifiStore();
const { fetchedCardState } = storeToRefs(notifiStore);
</script>
